<div class="mech-diag-content">
	<p>Tach display is in flux</p>
	<app-dvs-chart [error]="errormessage" [options]="tsoptions"></app-dvs-chart>
	<app-dvs-chart [error]="errormessage" [options]="spectrumoptions"></app-dvs-chart>
</div>